<template>
    <v-container>
        <v-layout wrap>
            <v-flex xs12>
                <v-card color="grey lighten-4">
                    <loader v-if="loading" />
                    <template v-if="!loading">
                    <v-container>
                    <h1>{{ data.DisplayName }}</h1>

                    <h3>Period of service</h3>
                    <p>{{ data.DateStart | stringDateFormat }}–{{ data.DateEnd | stringDateFormat }}</p>
                    <div v-if="data.Biography">
                    <h3>Biography</h3>
                    <div v-if="data.ADBLink"><a :href="data.ADBLink" target="_blank">Australian Dictionary of Biography</a></div>
                    <br/>
                    <p class="biography-text" v-html="data.Biography"></p>
                    </div>
                    </v-container>
                    </template>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ['id'],
    components: {
        Loader
    },
    data() {
        return {
            loading: true,
            data: null
        }
    },
    created() {
        this.initialiseData();
    },
    methods: {
        initialiseData() {
            this.loading = true;
            const url = `HistoricalInformation/OfficeHolder?id=${this.id}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.data = response.data;
                    this.loading = false;
                    if (this.data != null){
                        window.document.title = this.data.DisplayName;   
                    }
                });
        }
    }
}
</script>
<style lang="stylus" scoped>
    .biography-text >>> div, .biography-text >>> p {
        background: transparent !important;
    }
</style>